<template>
  <div>
    <div class="flex mb-5">
      <div class="w-6/12">
        <h1 class="text-xl font-bold text-gray-700">Users</h1>
      </div>
      <div class="w-6/12">
        <el-switch
          class="mr-5"
          v-model="withDeleted"
          active-text="Inactive"
          inactive-text="Active"
          :active-value="1"
          :inactive-value="0"
          @change="handleWithDeletedChange"
        >
        </el-switch>
        <base-button-primary @click="newUser" class="float-right"
          >New User</base-button-primary
        >
      </div>
    </div>

    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="users"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <base-button-primary-extra-small @click="handleEdit(props.row)">
                Edit
              </base-button-primary-extra-small>

              <base-button-white-extra-small
                v-if="!props.row.deleted_at"
                @click="handleDelete(props.row)"
                class="ml-3"
              >
                Make Inactive
              </base-button-white-extra-small>
              <base-button-white-extra-small
                v-else
                @click="handleRestore(props.row)"
                class="ml-3"
              >
                Restore
              </base-button-white-extra-small>

              <!--              <base-button-white-extra-small-->
              <!--                v-if="props.row.role !== 'Admin'"-->
              <!--                @click="handleLogin(props.row)"-->
              <!--                class="ml-3"-->
              <!--              >-->
              <!--                Login-->
              <!--              </base-button-white-extra-small>-->
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <user
      :show-modal="showModal"
      :user="user"
      @saved="save"
      @close="showModal = false"
    ></user>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import User from "@/components/common/User";
export default {
  name: "Users",
  components: { VueGoodTable, User },
  data() {
    return {
      withDeleted: 0,
      showModal: false,
      user: {
        id: null,
        name: "",
        email: "",
        password: "",
        role: "",
        outfitter_id: null,
        is_photographer: "No",
      },
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Role",
          field: "role",
        },
        {
          label: "Outfitter",
          field: "outfitter.name",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    handleLogin(row) {
      this.$store.dispatch("auth/login_as", row.id).then((resp) => {
        if (!resp.success) return;

        const user = this.$store.getters["auth/getUser"];
        if (user.role === "admin") {
          window.location.href = "/admin";
        } else if (user.role === "outfitter") {
          window.location.href = "/dashboard";
        } else if (user.role === "employee") {
          window.location.href = "/dashboard/pending-orders";
        } else if (user.role === "photographer") {
          window.location.href = "/photographer";
        } else {
          window.location.href = "/";
        }
      });
    },
    handleWithDeletedChange() {
      this.$store.dispatch("user/reload", { withDeleted: this.withDeleted });
    },
    newUser() {
      this.user = {
        id: null,
        name: "",
        email: "",
        password: "",
        outfitter_id: null,
        role: "",
        is_photographer: "No",
      };
      this.showModal = true;
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to remove this user?")) {
        this.$store
          .dispatch("user/delete_user", { id: row.id })
          .then((resp) => {
            if (!resp.success) return;

            this.$store.dispatch("user/reload", {
              withDeleted: this.withDeleted,
            });
          });
      }
    },
    handleRestore(row) {
      this.$store.dispatch("user/restore_user", { id: row.id }).then((resp) => {
        if (!resp.success) return;

        this.$store.dispatch("user/reload", {
          withDeleted: this.withDeleted,
        });
      });
    },
    save() {
      this.$store.dispatch("user/reload", { withDeleted: this.withDeleted });
      this.$notify({
        title: "User",
        message: "Data Saved",
        type: "success",
      });
      this.showModal = false;
      this.user = {
        id: null,
        name: "",
        email: "",
        password: "",
        outfitter_id: null,
        is_photographer: "No",
      };
    },
    handleEdit(row) {
      this.user = {
        id: row.id,
        name: row.name,
        role: row.role,
        email: row.email,
        outfitter_id: row.outfitter_id,
        is_photographer: row.is_photographer ? "Yes" : "No",
      };
      this.showModal = true;
    },
  },
  computed: {
    users: function () {
      return this.$store.getters["user/getUsers"];
    },
    outfitters: function () {
      return this.$store.getters["outfitter/getOutfitters"];
    },
  },
  mounted() {
    this.$store.dispatch("user/all", { withDeleted: this.withDeleted });
    this.$store.dispatch("outfitter/all", { withDeleted: 0 });
  },
};
</script>
